import { ShiftManagementPageDocument } from 'generated/resources/graphql'

import AuthorizeUser from 'modules/core/components/AuthorizeUser'
import { useQuery } from 'modules/core/hooks/useQuery'

import { ResponsivePage } from 'modules/layout/components/ResponsivePage'
import { usePageStatus } from 'modules/layout/components/ResponsivePage/FactorialOnePage/usePageStatus'
import { useLayoutContext } from 'modules/layout/hooks/useFullscreen'
import SavedShiftsSettings from 'modules/shift_management/components/Settings/SavedShifts'

const SavedShiftsPage = () => {
  const { isFullScreen, toggleFullScreen } = useLayoutContext()

  if (isFullScreen) toggleFullScreen()

  const { data, loading, error } = useQuery(ShiftManagementPageDocument, {})
  const canManageDefaultShifts = data?.shiftManagement?._policies.defaultShiftManage.can

  const { clearPageStatus } = usePageStatus()
  clearPageStatus()

  return (
    <AuthorizeUser authorizeFn={() => !!canManageDefaultShifts}>
      <ResponsivePage.Body showHeader={false} variant="wide" loading={loading} error={error}>
        <SavedShiftsSettings />
      </ResponsivePage.Body>
    </AuthorizeUser>
  )
}

export default SavedShiftsPage
